import { useState } from "react";
import { Context } from "../types";
import { Action } from "./useHabitState";

export const useContextActions = (dispatch: React.Dispatch<Action>) => {
  const [addContextDialogOpen, setAddContextDialogOpen] = useState(false);
  const [editContextDialogOpen, setEditContextDialogOpen] = useState(false);
  const [currentContext, setCurrentContext] = useState<Context | null>(null);

  const handleAddContext = () => {
    const newContext: Context = {
      id: Date.now(),
      name: "",
      color: "#6c5ce7",
      archived: false,
    };
    setCurrentContext(newContext);
    setAddContextDialogOpen(true);
  };

  const handleEditContext = (context: Context) => {
    setCurrentContext(context);
    setEditContextDialogOpen(true);
  };

  const handleSaveContext = () => {
    if (currentContext?.name) {
      if (editContextDialogOpen) {
        dispatch({ type: "EDIT_CONTEXT", payload: currentContext });
      } else {
        dispatch({ type: "ADD_CONTEXT", payload: currentContext });
      }
      setAddContextDialogOpen(false);
      setEditContextDialogOpen(false);
    }
  };

  const handleRemoveContext = (id: number) => {
    dispatch({ type: "REMOVE_CONTEXT", payload: id });
    setEditContextDialogOpen(false);
  };

  const handleArchiveContext = (id: number) => {
    dispatch({ type: "ARCHIVE_CONTEXT", payload: id });
    setEditContextDialogOpen(false);
  };

  const handleToggleContext = (date: string, contextId: number) => {
    dispatch({ type: "TOGGLE_CONTEXT", payload: { date, contextId } });
  };

  return {
    addContextDialogOpen,
    setAddContextDialogOpen,
    editContextDialogOpen,
    setEditContextDialogOpen,
    currentContext,
    setCurrentContext,
    handleAddContext,
    handleEditContext,
    handleSaveContext,
    handleRemoveContext,
    handleArchiveContext,
    handleToggleContext,
  };
};